import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withAreaGetter } from 'providers/AreasConsumers';
import { areas } from 'constants/areas';
import ScheduleTypeCellParamTemplateListBrowser from './ScheduleTypeCellParamTemplateListBrowser';
import Portal from 'utils/portal/Portal';
import HeaderLinks from './header/HeaderLinks';
import HeaderTitle from './header/HeaderTitle';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { ADMIN_SCHEDULES_READ, ADMIN_SCHEDULES_WRITE } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';
import { usePermission } from 'providers/RightsHooks';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  const canWrite = usePermission(ADMIN_SCHEDULES_WRITE);

  const onAdd = () => {
    historyContext.push(`/scheduleTypeCellParamTemplates/new`);
  };

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <HeaderTitle />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_SCHEDULES_WRITE} withForbiddenPage={false}>
          <HeaderLinks onAdd={onAdd} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_SCHEDULES_READ}>
        <ScheduleTypeCellParamTemplateListBrowser canWrite={canWrite} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
